import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

const periodNames: { [key: number]: string } = {
  1: Dictionary[DICTIONARY.Equipment].createOrder.month1,
  2: Dictionary[DICTIONARY.Equipment].createOrder.month2,
  3: Dictionary[DICTIONARY.Equipment].createOrder.month3,
  6: Dictionary[DICTIONARY.Equipment].createOrder.month6,
};

const periodValues: { [key: string]: number } = {
  [Dictionary[DICTIONARY.Equipment].createOrder.month1]: 1,
  [Dictionary[DICTIONARY.Equipment].createOrder.month2]: 2,
  [Dictionary[DICTIONARY.Equipment].createOrder.month3]: 3,
  [Dictionary[DICTIONARY.Equipment].createOrder.month6]: 6,
};

export const getPeriodLabel = (period: number) => {
  return periodNames[period] || periodNames[1];
};
export const getPeriodNumber = (period: string) => {
  return periodValues[period] || periodValues.month1;
};
